<template>
	<!-- 修改密码弹窗 - 增加响应式宽度 + 自定义class -->
	<el-dialog 
		title="修改密码" 
		:visible.sync="visible" 
		:width="dialogWidth"
		:modal-append-to-body="false"
		:append-to-body="true"
		class="custom-pwd-dialog"
		@close="close"
	>
		<el-form 
			:model="form" 
			label-width="80px" 
			ref="formRef"
			class="custom-pwd-form"
			:label-position="labelPosition"
		>
			<el-form-item label="旧密码" prop="oldPwd" class="form-item">
				<el-input 
					v-model="form.oldPwd" 
					type="password" 
					placeholder="请输入旧密码"
					:size="inputSize"
				/>
			</el-form-item>

			<el-form-item label="新密码" prop="newPwd" class="form-item">
				<el-input 
					v-model="form.newPwd" 
					type="password" 
					placeholder="请输入新密码"
					:size="inputSize"
				/>
			</el-form-item>

			<el-form-item label="确认密码" prop="confirmPwd" class="form-item">
				<el-input 
					v-model="form.confirmPwd" 
					type="password" 
					placeholder="请确认新密码"
					:size="inputSize"
				/>
			</el-form-item>
		</el-form>

		<div slot="footer" class="dialog-footer custom-footer">
			<el-button 
				@click="close"
				:size="buttonSize"
			>取消</el-button>
			<el-button 
				type="primary" 
				@click="submit"
				:size="buttonSize"
			>确认修改</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'Password',
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form: {
					oldPwd: '',
					newPwd: '',
					confirmPwd: ''
				}
			}
		},
		computed: {
			// 弹窗可见性（保持原有逻辑）
			visible: {
				get() {
					return this.show
				},
				set(val) {
					this.$emit('update:show', val)
				},
			},
			// 响应式弹窗宽度
			dialogWidth() {
				const screenWidth = window.innerWidth;
				if (screenWidth < 576) { // 手机端
					return '90%'; // 占屏幕90%宽度
				} else if (screenWidth < 768) { // 平板端
					return '70%';
				} else { // PC端
					return '400px'; // 原有宽度
				}
			},
			// 响应式表单标签位置（手机端改为顶部，更易操作）
			labelPosition() {
				return window.innerWidth < 576 ? 'top' : 'right';
			},
			// 响应式输入框尺寸
			inputSize() {
				return window.innerWidth < 576 ? 'medium' : 'default';
			},
			// 响应式按钮尺寸
			buttonSize() {
				return window.innerWidth < 576 ? 'medium' : 'default';
			}
		},
		mounted() {
			// 监听窗口大小变化，重新计算响应式属性
			window.addEventListener('resize', () => {
				this.$forceUpdate(); // 强制更新计算属性
			});
		},
		beforeDestroy() {
			// 移除监听，避免内存泄漏
			window.removeEventListener('resize', () => {
				this.$forceUpdate();
			});
		},
		methods: {
			// 关闭弹窗（保持原有逻辑）
			close() {
				this.$emit('update:show', false)
				this.form = {
					oldPwd: '',
					newPwd: '',
					confirmPwd: ''
				}
			},
			// 提交修改（保持原有逻辑）
			submit() {
				const { oldPwd, newPwd, confirmPwd } = this.form
				  
				if (!oldPwd) return this.$message.error('请输入旧密码')
				if (!newPwd) return this.$message.error('请输入新密码')
				if (newPwd !== confirmPwd) return this.$message.error('两次密码不一致')
				
				let userType = localStorage.getItem('userType')
				let userId = localStorage.getItem('userId')
				
				// 1是中台
				if (userType == 1) {
					this.API.put(`${this.API.admin.PutAdminPwd}?adminId=${userId}&oldPwd=${oldPwd}&newPwd=${newPwd}`)
						.then(res => {
							if(res.data.code===200){
								this.$message.success('密码修改成功')
								this.subType()
							}else{
								this.$message.error(res.data.msg)
							}
						}).catch(()=>{})
				}
				
				if(userType == 2){
					this.API.put(`${this.API.school.PutSchoolPwd}?userId=${userId}&oldPwd=${oldPwd}&newPwd=${newPwd}`)
						.then(res => {
							if(res.data.code===200){
								this.$message.success('密码修改成功')
								this.subType()
							}else{
								this.$message.error(res.data.msg)
							}
						}).catch(()=>{})
				}
			},
			// 提交成功回调（保持原有逻辑）
			subType() {
				this.$emit('change-pwd', 'false')
				this.close()
			},
		}
	}
</script>

<style scoped>
/* 基础适配样式 */
.custom-pwd-dialog {
	box-sizing: border-box;
	padding: 0 !important;
}

/* 表单适配 */
.custom-pwd-form {
	padding: 10px;
	box-sizing: border-box;
}

/* 表单项间距（手机端加大） */
.form-item {
	margin-bottom: 18px !important;
}

/* 底部按钮区适配 */
.custom-footer {
	display: flex;
	justify-content: center;
	gap: 15px; /* 按钮间距 */
	padding: 10px 0;
	box-sizing: border-box;
}

/* 媒体查询 - 手机端（<576px） */
@media (max-width: 575px) {
	.form-item {
		margin-bottom: 15px !important;
	}
	.custom-footer {
		flex-direction: column; /* 手机端按钮垂直排列 */
		padding: 0 10px 10px;
	}
	.custom-footer .el-button {
		width: 100%; /* 按钮占满宽度 */
	}
}

/* 媒体查询 - 平板端（576px~767px） */
@media (min-width: 576px) and (max-width: 767px) {
	.custom-footer {
		gap: 20px;
	}
	.form-item {
		margin-bottom: 20px !important;
	}
}

/* PC端（>768px）保持原有样式 */
@media (min-width: 768px) {
	.custom-pwd-form {
		padding: 20px;
	}
	.custom-footer {
		padding: 15px 20px;
	}
}
</style>